/**
 * Terrain band overlay’lerinde ortak “Haritaya dön” kontrolü.
 * Harita chrome (uydu / tam ekran / aksiyon) butonlarıyla aynı görünüm.
 */
export default function TerrainBandBackToMapButton({
  onClick,
  title = 'Haritaya dön',
  ariaLabel = 'Haritaya dön',
}) {
  if (typeof onClick !== 'function') return null;
  return (
    <button
      type="button"
      className="pp-detail-map-action-btn pp-detail-terrain-band__back-to-map-btn"
      onClick={onClick}
      title={title}
      aria-label={ariaLabel}
    >
      <i className="fas fa-map" aria-hidden="true" />
    </button>
  );
}
